
import { useRecoilValue } from "recoil";
import { routesState } from "state/ecoState";
import { EcoRoute } from "types";

/** 
 * 
 * Hook to get authorized routes
 * 
 */
export function useEcoRoutes(): EcoRoute[]{
    return useRecoilValue(routesState) ;
}

export default useEcoRoutes ;
